import { useState } from "react";

export const faqs = [
  {
    question: "La manivelle tourne dans le vide, pourquoi ?",
    answer: "C'est le symptôme le plus courant d'une défaillance du mécanisme de transmission. Les causes principales sont : les pignons du treuil interne sont usés ou brisés, le cardan de liaison est déboîté ou cassé, ou la sortie de caisson est déformée et ne transmet plus la rotation. Dans tous les cas, la manivelle tourne librement car rien ne relie plus la poignée à l'enrouleur du tablier.",
  },
  {
    question: "Faut-il tout changer ou peut-on réparer une partie ?",
    answer: "Pas forcément. Dans environ 40 % des cas, seule une pièce est défectueuse : le cardan, le ressort de rappel, ou la sortie de caisson. Notre technicien démonte la manivelle et inspecte chaque composant pour identifier la pièce exacte en cause. Si le treuil est encore en bon état, nous ne changeons que la pièce défectueuse. Si le treuil est usé, nous proposons un remplacement complet avec une pièce neuve adaptée au poids de votre tablier.",
  },
  {
    question: "Combien de temps dure l'intervention ?",
    answer: "Une réparation de manivelle simple (resserrage, repositionnement du cardan, graissage) prend entre 20 et 30 minutes. Un remplacement complet du mécanisme (treuil + cardan + sortie de caisson) prend entre 45 minutes et 1h30 selon l'accessibilité du coffre et le type de tablier. Nous intervenons avec un stock de pièces courantes, ce qui évite les délais d'attente.",
  },
  {
    question: "Quel est le prix d'un remplacement de manivelle ou de mécanisme ?",
    answer: "Le tarif dépend de l'ampleur de l'intervention. Une simple réparation (pièce déboîtée, graissage, réglage) est facturée au forfait de déplacement. Un remplacement de mécanisme complet inclut le démontage, la pose de la pièce neuve et le réglage. Nous établissons un devis détaillé et gratuit sur place avant de commencer les travaux. Aucune surprise, aucun tarif inventé.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions fréquentes sur la réparation de manivelle
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-brand-border rounded-xl overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-brand-light/50 transition-colors"
              >
                <span className="font-semibold text-brand-blue text-sm md:text-base pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-brand-cyan text-xl transition-transform shrink-0 ${open === i ? "rotate-180" : ""}`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-brand-text leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}